import { MappingClientT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext } from 'react';
import { AppContext } from '../../../../../state/app.state';
import Polygon from '../../Polygon/Polygon';

type SvgMappingPoiPolygonsProps={
    lastHovered: string;
    setLastHovered: (value: string) => void;
    onObjectMouseEnter?: (object: MappingClientT) => void;
    onObjectMouseLeave?: (object: MappingClientT) => void;
    checkHoverTimer?: () => boolean;
    disableObjectTouchInteraction: boolean;
};

const SvgMappingPoiPolygons: React.FC<SvgMappingPoiPolygonsProps> = ({ lastHovered, setLastHovered, onObjectMouseEnter, onObjectMouseLeave, checkHoverTimer, disableObjectTouchInteraction }): ReactElement => {
    const { state, presentationState } = useContext(AppContext);

    const getClassName = (p: MappingClientT): string => {
        let className = 'bv-poi';

        if (presentationState?.activePreview) {
            className = className.concat(' bv-mapping-fade');
        }

        if (!presentationState?.activePreview && !state?.isCurrentPreviewObject(p.mappingEntityId) && lastHovered !== `bv-polygon-poi-${p.id}` && checkHoverTimer && checkHoverTimer()) {
            className = className.concat(' bv-mapping-fade-in');
        }

        if (state?.isCurrentPreviewObject(p.mappingEntityId)) {
            className = className.concat(' bv-pop-animation');
        }

        return className;
    };

    const onMouseEnter = (p: MappingClientT): void => {
        p.mappingEntityId && state?.setPreviewObjectId(p.mappingEntityId);
        setLastHovered(`bv-polygon-poi-${p.id}`);

        if (onObjectMouseEnter) {
            onObjectMouseEnter(p);
        }
    };

    const onMouseLeave = (p: MappingClientT): void => {
        state?.setPreviewObjectId(undefined);
        setLastHovered('');

        if (onObjectMouseLeave) {
            onObjectMouseLeave(p);
        }
    };

    return useObserver(() => (
        <>

            {state?.currentView?.mappings.poiContainers?.map((p: MappingClientT, index: number) => {

                return <Polygon
                    key={p.id}
                    disablePolygonTouchInteraction={disableObjectTouchInteraction}
                    polygon={p.polycords}
                    className={getClassName(p)}
                    id={`bv-poi-polygon-${p.id}`}
                    onMouseEnter={() => onMouseEnter(p)}
                    onMouseLeave={() => onMouseLeave(p)}
                />;
            })}
        </>
    ));
};


export default SvgMappingPoiPolygons;